// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1527":"aa8ce8f1","4282":"c3232f85","6777":"c3232f85"}[chunkId] + ".chunk.css";
};